import VehicleRequestWrapper from './VehicleRequestWrapper'

export const FetchUserVehicles = async (webUserGuid, prevState, customerProjectUrl, selectedFacetData) => {
    if (!customerProjectUrl || prevState?.customerVehicles) {
        return prevState
    }

    let variables = {
        webUserGuid: webUserGuid,
        selectedFacetData
    }

    const query = `query GetCustomerProjects($webUserGuid: String = null, $selectedFacetData: SelectedFacetDataDMInput = null) {
        customerProjects(webUserGuid: $webUserGuid, selectedFacetData: $selectedFacetData) {
            year
            make
            makeId
            model
            modelId
            raceName
            raceTypeId
            raceImageUrl
            shopUrl
            searchUrl
            projectId
            marketId
            superMarketId
            vehicleBaseId
      }
    }`

    var temp = await VehicleRequestWrapper(query, variables, customerProjectUrl)
    return temp
}

export const FetchRaceTypes = async (state, traitsUrl, selectedFacetData) => {
    if (!state.raceTypes || state.raceTypes.length === 0) {
        let query = `query GetRaceTypeLinks($selectedFacetData: SelectedFacetDataDMInput = null){
              raceTypeLinks(selectedFacetData: $selectedFacetData){
                displayName
                imageUrl
                shopUrl
                searchUrl
                raceTypeId
                marketId
                superMarketId
                priority
                }
            }`
        let variables = {
            selectedFacetData
        }
        return await VehicleRequestWrapper(query, variables, traitsUrl)
    }
    return state.raceTypes
}

export const FetchYearMakeModel = async (state, yearId, makeId, modelId, traitsUrl, selectedFacetData) => {
    if (state.allYears && state.allYears?.length !== 0 && !yearId) {
        return state
    }

    let query = `query GetYmm($request: YmmRequestInput! = null){
         ymm(request: $request){
            years{
                displayName
                optionId
            }
            prioritizedMakes{
                displayName
                optionId
            }
            makes{
                displayName
                optionId
            }
            models{
                displayName
                optionId
                shopUrl
                searchUrl
                marketId
                superMarketId
                vehicleBaseId
            }
         }
    }`

    let variables = {
        request: {
            year: yearId,
            make: makeId,
            model: modelId,
            selectedFacetData: selectedFacetData
        }
    }

    return await VehicleRequestWrapper(query, variables, traitsUrl)
}
export const getPropperUrl = (item) => {
    if (window.location.pathname.toLowerCase().includes('search')) {
        const params = new URLSearchParams(window.location.search)
        const searchTerm = params.get('query');
        if (!searchTerm) {
            console.error("search url didn't have a search query!")
            return item.shopUrl;
        }
        return item.searchUrl.replace('?', `?query=${searchTerm}&`)
    }
    return item.shopUrl
}

export const FetchEngine = async (makeString, engineFamilyId, traitsUrl) => {

    let query = `query GetEngineLinks($request: EngineRequestInput! = null){
        engineLinks(request: $request){
            displayName
            engineId
            url
        }
    }`
    let variables = {}
    if (engineFamilyId) {
        variables = {
            request: {
                engineFamilyId: engineFamilyId
            }
        }
    }
    else if (makeString) {
        variables = {
            request: {
                make: makeString,
            }
        }
    }




    return await VehicleRequestWrapper(query, variables, traitsUrl)
}

export const RemoveUserVehicle = async (webUserGuid, projectId, customerProjectUrl) => {
    let query = `mutation RemoveProjectFromGarage($projectToRemove: ProjectRemoveRequestInput = null) {
    removeProjectFromGarage(projectToRemove: $projectToRemove) 
     {
      success
      projects {
          year
          make
          makeId
          model
          modelId
          shopUrl
          searchUrl
          vehicleBaseId
          raceTypeId
          raceImageUrl
          raceName
          vehicleTruncatedName
          projectId
          dateUpdated
          marketId
          superMarketId
      }
      message
    }
    }`

    let variables = {
        projectToRemove: {
            webUserGuid: webUserGuid,
            projectId: projectId
        }
    }

    return await VehicleRequestWrapper(query, variables, customerProjectUrl)
}

export const AddUserVehicle = async (
    webUserGuid,
    customerProjectUrl,
    yearId,
    makeId,
    modelId,
    raceTypeId,
    vehicleBaseId,
    selectedFacetData
) => {
    let query = `mutation AddNewProjectToGarage($projectRequest: ProjectRequestInput = null) {
        addNewProjectToGarage(projectRequest: $projectRequest) 
         {
          success
          alreadyExisted
          projects {
            year
            make
            makeId
            model
            modelId
            shopUrl
            searchUrl
            raceTypeId
            raceImageUrl
            raceName
            projectId
            marketId
            superMarketId
            vehicleBaseId
          }
          webUser {
            userGuid
          }
          message
        }
    }`

    let variables = {
        projectRequest: {
            year: yearId,
            makeId: makeId,
            modelId: modelId,
            raceTypeId: raceTypeId,
            webUserGuid: webUserGuid,
            customerProjectSource: 'CUSTOMER_ENTERED',
            vehicleBaseId: vehicleBaseId,
            selectedFacetData: selectedFacetData
        }
    }

    return await VehicleRequestWrapper(query, variables, customerProjectUrl)
}